import React from 'react';

import { Tabs } from '@eika/tabs';

import FindIBAN from './components/findIBAN';
import ValidateIBAN from './components/validateIBAN';
import { useConfig } from './config';

import './index.scss';

const SitecorePageComponent = () => {
    const config = useConfig();

    return (
        <div className="sgw-content">
            <Tabs>
                <Tabs.TabList>
                    <Tabs.TabButton value="find">{config.texts.tabTitleFind}</Tabs.TabButton>
                    <Tabs.TabButton value="check">{config.texts.tabTitleValidate}</Tabs.TabButton>
                </Tabs.TabList>
                <Tabs.Tab value="find">
                    <div className="esc-ibangenerator esc-ibangenerator--generate">
                        <p className="typography-ingress__light">{config.texts.tabContentFind}</p>
                        <FindIBAN texts={config.texts} />
                    </div>
                </Tabs.Tab>
                <Tabs.Tab value="check">
                    <div className="esc-ibangenerator esc-ibangenerator--validate">
                        <p className="typography-ingress__light">{config.texts.tabContentValidate}</p>
                        <ValidateIBAN texts={config.texts} />
                    </div>
                </Tabs.Tab>
            </Tabs>
        </div>
    );
};

export default SitecorePageComponent;
